import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle, getDeleteAllAction } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { ShowTeaser } from '../../../components/Teaser/ShowTeaser/ShowTeaser';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useDataDispatch } from '../../../providers/DataProvider/DataContext';
import { useFavoriteShows } from '../../../providers/DataProvider/use-favorite-shows';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FavoriteShows = () => {
  const {
    t
  } = useTranslation();
  const {
    usePreview
  } = useVideoConfig();
  const dataDispatch = useDataDispatch();
  const {
    favoriteShows,
    isLoading,
    error
  } = useFavoriteShows();
  const showPosterImage = favoriteShows.every(show => !show.posterImageIsFallbackUrl);
  const aspectRatio = showPosterImage ? 2 / 3 : 16 / 9;
  const showSwimlane = !error && favoriteShows.length > 0 || isLoading || usePreview;
  return /*#__PURE__*/_jsx(Fragment, {
    children: showSwimlane && /*#__PURE__*/_jsxs(Swimlane, {
      children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
        title: t('home.favoriteShows'),
        actionButton: getDeleteAllAction(t, favoriteShows.length, () => dataDispatch({
          type: 'clear-show-favorites'
        }))
      }), /*#__PURE__*/_jsx(Swipeable, {
        placeholderAspectRatio: aspectRatio,
        isPersonalized: true,
        analyticsTitle: "FavoriteShows",
        children: favoriteShows.map((show, index) => /*#__PURE__*/_jsx(ShowTeaser, {
          show: show,
          index: index,
          showPosterImage: showPosterImage,
          showFavoriteUndo: true
        }, show.id))
      })]
    })
  });
};